import type { TvsActionType } from "@whatslly/types/SfQueryApiResponse";
import { WidgetCommands } from "@whatslly/commons/widgetCommands";
import { widgetClient } from "@whatslly/commons/widgetClient";

export type ItemType = { MasterLabel: string; Id: string; tvsAction?: TvsActionType; ApiName: string; IsClosed?: boolean };

export const updateItemAndHandleError = (
  item: ItemType,
  prevItem: ItemType,
  parentItemId: string,
  setCurrentItemValue: (newValue: string) => void,
  parentItemType: "Opportunity" | "Lead"
) => {
  if (item.tvsAction?.action === "set" || item.tvsAction?.action === "modal") {
    setCurrentItemValue(item.MasterLabel);
    widgetClient.send(WidgetCommands.STATUS_BAR_ITEM_SELECTED, {
      action: item.tvsAction.action,
      selectedItemApiName: item.ApiName,
      selectedItemValue: item.MasterLabel,
      parentItemType,
      parentItemId,
      fields: item.tvsAction.fields,
      prevSelectedItemValue: prevItem.MasterLabel,
    });
  }
};
